import React from "react";

const HASHTAG_REGEX = /(#[\p{L}\p{N}_]+)/gu;

export const renderFacebookText = (text = "") => {
  return text.split(HASHTAG_REGEX).map((part, index) => {
    if (part.match(/^#[\p{L}\p{N}_]+$/u)) {
      return (
        <span
          key={`${part}-${index}`}
          className="school-social-hero__hashtag"
        >
          {part}
        </span>
      );
    }

    return part;
  });
};